module.exports = __webpack_public_path__ + "static/media/filter_circle_icon.ecfa563e.svg";